import React, { useState } from 'react'

const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modal: {
    background: '#fff',
    padding: '32px',
    maxWidth: '400px',
    width: '100%',
    border: '2px solid var(--color-border)',
  },
  title: {
    marginTop: 0,
    marginBottom: '16px',
  },
  field: {
    marginBottom: '16px',
  },
  label: {
    display: 'block',
    fontWeight: '600',
    marginBottom: '8px',
  },
  input: {
    width: '100%',
    padding: '8px 12px',
    border: '2px solid var(--color-border)',
    fontSize: '1rem',
  },
  buttons: {
    display: 'flex',
    gap: '12px',
    marginTop: '24px',
  },
  btn: {
    flex: 1,
    padding: '12px 24px',
    border: '2px solid var(--color-border)',
    background: 'var(--color-primary)',
    color: '#fff',
    fontWeight: '600',
    cursor: 'pointer',
  },
  btnSecondary: {
    background: '#fff',
    color: 'var(--color-primary)',
  },
  success: {
    background: 'var(--color-light)',
    padding: '16px',
    marginTop: '16px',
    border: '1px solid var(--color-border)',
  },
  link: {
    fontFamily: 'var(--font-mono)',
    fontSize: '0.9rem',
    wordBreak: 'break-all',
    display: 'block',
    marginTop: '8px',
    padding: '8px',
    background: '#fff',
    border: '1px solid var(--color-border)',
  },
}

export default function PublishModal({ onClose, onPublish, publishedUrl }) {
  const [creatorName, setCreatorName] = useState('')
  const [isPublishing, setIsPublishing] = useState(false)

  const handlePublish = async () => {
    setIsPublishing(true)
    await onPublish(creatorName)
    setIsPublishing(false)
  }

  const copyLink = () => {
    navigator.clipboard.writeText(publishedUrl)
  }

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>
        {!publishedUrl ? (
          <>
            <h2 style={styles.title}>Publish Puzzle</h2>
            <p>Make your puzzle available for others to solve.</p>

            <div style={styles.field}>
              <label style={styles.label}>Your Name (optional)</label>
              <input
                type="text"
                value={creatorName}
                onChange={e => setCreatorName(e.target.value)}
                placeholder="Anonymous"
                style={styles.input}
              />
            </div>

            <div style={styles.buttons}>
              <button
                style={{ ...styles.btn, ...styles.btnSecondary }}
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                style={styles.btn}
                onClick={handlePublish}
                disabled={isPublishing}
              >
                {isPublishing ? 'Publishing...' : 'Publish'}
              </button>
            </div>
          </>
        ) : (
          <>
            <h2 style={styles.title}>Puzzle Published!</h2>
            <p>Share this link with friends to let them solve your puzzle:</p>

            <div style={styles.success}>
              <strong>Share Link:</strong>
              <code style={styles.link}>{publishedUrl}</code>
              <button
                style={{ ...styles.btn, marginTop: '12px' }}
                onClick={copyLink}
              >
                Copy Link
              </button>
            </div>

            <div style={styles.buttons}>
              <button style={styles.btn} onClick={onClose}>
                Done
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
